/**
 * Per-market game rankings by bet volume (from ClickHouse)
 * Period: March 2026
 */
const MARKET_RANKINGS = {
  brazil: {
    'lucky-caramelo-2': 1,
    'swaggy-caramelo': 2,
    'prosperity-rabbit': 3,
    'firecrackers-fortune': 4,
    'prosperity-ox': 5,
    'swaggy-caramelo-super': 6,
    'prosperity-dragon': 7,
    'prosperity-tiger': 8,
    'fortune-pig': 9,
    'shapes-of-fortune': 10,
    'the-lucky-year': 11,
    'lucky-panda': 12,
    'lucky-caramelo-1000': 13,
    'shapes-of-fortune-xmas': 14,
    'prosperity-mouse': 15,
    'money-mania': 16,
    'lucky-fox': 17,
    'lucky-turtle': 18,
    'lucky-snake': 19,
    'firecrackers-fortune-100': 20,
    'prosperity-dragon-golden-reel': 21,
    'smash-fury': 22,
    'fiesta-blue': 23,
    'year-of-the-golden-horse': 24,
    'lucky-duck': 25,
    'fiesta-green': 26,
    'prosperity-horse': 27,
    'iron-valor': 28,
    'pirates-treasure-reel': 29,
    'fiesta-magenta': 30,
    'fiesta-red': 31,
    'realm-of-thunder': 32,
    'capricorns-orb-of-fortune': 33,
    'disco-fever': 34,
    'black-assassin': 35,
    'tinkering-box': 36,
    'pisces-realm-of-fortune': 37,
    'aquarius-fortune-wheel': 38,
    'rudolphs-gift': 39,
    'aztecs-mystery': 40,
    'farmageddon': 41,
    'gold-diggers': 42,
    'battleship': 43,
    'inmate-outcuss': 44,
    'prosperity-clash': 45,
    'wheel-of-wealth': 46,
    'mines': 47,
    'eggy-pop': 48,
    'treasures-of-hades': 49,
    'the-lone-fireball': 50,
    'limbo': 51,
    'magic-circus': 52,
    'golden-koi-trail': 53,
    'semana-santa-treasures': 54,
    'solar-pong': 55,
    'chicken-uncrossable': 56,
    'pig-mines': 57,
    'blackjack': 58,
    'plinko': 59,
    'balonismo': 60,
    'dragon-crash': 61,
    'crash': 62,
    'dice': 63,
    'one-wrong-step': 64,
    'coin-flip': 65,
    'wheel': 66,
    'diamonds': 67,
    'keno': 68,
    'roulette': 69,
    'coin-race': 70,
    'hilo': 71,
  },
  mexico: {
    'lucky-caramelo-2': 1,
    'firecrackers-fortune': 2,
    'lucky-caramelo-1000': 3,
    'swaggy-caramelo': 4,
    'prosperity-rabbit': 5,
    'swaggy-caramelo-super': 6,
    'firecrackers-fortune-100': 7,
    'prosperity-ox': 8,
    'year-of-the-golden-horse': 9,
    'prosperity-dragon': 10,
    'prosperity-horse': 11,
    'capricorns-orb-of-fortune': 12,
    'prosperity-tiger': 13,
    'prosperity-clash': 14,
    'shapes-of-fortune': 15,
    'aquarius-fortune-wheel': 16,
    'wheel-of-wealth': 17,
    'fortune-pig': 18,
    'mines': 19,
    'blackjack': 20,
    'shapes-of-fortune-xmas': 21,
    'pisces-realm-of-fortune': 22,
    'pirates-treasure-reel': 23,
    'lucky-panda': 24,
    'plinko': 25,
    'prosperity-mouse': 26,
    'lucky-fox': 27,
    'prosperity-dragon-golden-reel': 28,
    'the-lone-fireball': 29,
    'wheel': 30,
    'the-lucky-year': 31,
    'coin-flip': 32,
    'lucky-snake': 33,
    'money-mania': 34,
    'dice': 35,
    'fiesta-blue': 36,
    'lucky-turtle': 37,
    'iron-valor': 38,
    'fiesta-magenta': 39,
    'lucky-duck': 40,
    'disco-fever': 41,
    'fiesta-green': 42,
    'smash-fury': 43,
    'one-wrong-step': 44,
    'fiesta-red': 45,
    'treasures-of-hades': 46,
    'semana-santa-treasures': 47,
    'aztecs-mystery': 48,
    'farmageddon': 49,
    'balonismo': 50,
    'magic-circus': 51,
    'golden-koi-trail': 52,
    'diamonds': 53,
    'eggy-pop': 54,
    'limbo': 55,
    'realm-of-thunder': 56,
    'keno': 57,
    'gold-diggers': 58,
    'battleship': 59,
    'black-assassin': 60,
    'roulette': 61,
    'rudolphs-gift': 62,
    'crash': 63,
    'tinkering-box': 64,
    'inmate-outcuss': 65,
    'chicken-uncrossable': 66,
    'hilo': 67,
    'pig-mines': 68,
    'solar-pong': 69,
    'dragon-crash': 70,
    'coin-race': 71,
  },
  asia: {
    'swaggy-caramelo': 1,
    'prosperity-rabbit': 2,
    'firecrackers-fortune': 3,
    'prosperity-ox': 4,
    'the-lone-fireball': 5,
    'fiesta-green': 6,
    'the-lucky-year': 7,
    'swaggy-caramelo-super': 8,
    'prosperity-mouse': 9,
    'lucky-panda': 10,
    'lucky-snake': 11,
    'smash-fury': 12,
    'prosperity-dragon': 13,
    'wheel-of-wealth': 14,
    'realm-of-thunder': 15,
    'disco-fever': 16,
    'money-mania': 17,
    'iron-valor': 18,
    'fiesta-blue': 19,
    'black-assassin': 20,
    'firecrackers-fortune-100': 21,
    'lucky-caramelo-2': 22,
    'aztecs-mystery': 23,
    'lucky-fox': 24,
    'fortune-pig': 25,
    'lucky-duck': 26,
    'prosperity-dragon-golden-reel': 27,
    'prosperity-tiger': 28,
    'shapes-of-fortune-xmas': 29,
    'lucky-turtle': 30,
    'battleship': 31,
    'magic-circus': 32,
    'solar-pong': 33,
    'lucky-caramelo-1000': 34,
    'rudolphs-gift': 35,
    'pirates-treasure-reel': 36,
    'gold-diggers': 37,
    'inmate-outcuss': 38,
    'aquarius-fortune-wheel': 39,
    'limbo': 40,
    'fiesta-magenta': 41,
    'fiesta-red': 42,
    'treasures-of-hades': 43,
    'tinkering-box': 44,
    'plinko': 45,
    'farmageddon': 46,
    'eggy-pop': 47,
    'golden-koi-trail': 48,
    'shapes-of-fortune': 49,
    'capricorns-orb-of-fortune': 50,
    'dice': 51,
    'year-of-the-golden-horse': 52,
    'pig-mines': 53,
    'crash': 54,
    'prosperity-horse': 55,
    'one-wrong-step': 56,
    'coin-flip': 57,
    'wheel': 58,
    'blackjack': 59,
    'keno': 60,
    'pisces-realm-of-fortune': 61,
    'coin-race': 62,
  },
  chinese: {
    'lucky-caramelo-2': 1,
    'smash-fury': 2,
    'the-lucky-year': 3,
    'fiesta-green': 4,
    'shapes-of-fortune-xmas': 5,
    'inmate-outcuss': 6,
    'the-lone-fireball': 7,
    'disco-fever': 8,
    'lucky-fox': 9,
    'swaggy-caramelo': 10,
    'fortune-pig': 11,
    'fiesta-blue': 12,
    'black-assassin': 13,
    'aztecs-mystery': 14,
    'realm-of-thunder': 15,
    'lucky-panda': 16,
    'gold-diggers': 17,
    'rudolphs-gift': 18,
    'lucky-snake': 19,
    'solar-pong': 20,
    'lucky-turtle': 21,
    'iron-valor': 22,
    'fiesta-red': 23,
    'farmageddon': 24,
    'money-mania': 25,
    'magic-circus': 26,
    'hilo': 27,
    'lucky-duck': 28,
  },
  europe: {
  },
};

export default MARKET_RANKINGS;
